import * as Mutations from './mutations';
import { UsersService } from '../../../common/services/settings/users.service';
import { UsersInvitationService } from '../../../common/services/settings/user-invitation.service';
import { PaginationParams } from '../../../common/utils/pagination-params';
import { SchoolService } from '../../../common/services/settings/school.service';
import { USER_TYPES } from '../../../constants/user-types';

export const UsersModule = {
    state: {
        users: null,
        userId: null,
        user: null,
        instructors: null
    },
    mutations: {
        [Mutations.SET_USERS] (state, users) {
            state.users = users;
        },

        [Mutations.SET_USER_ID] (state, userId) {
            state.userId = userId;
        },

        [Mutations.REMOVE_USER_ID] (state) {
            state.userId = null;
        },

        [Mutations.SET_USER] (state, user) {
            state.user = user;
        },

        [Mutations.REMOVE_USER] (state) {
            state.user = null;
        },

        [Mutations.SET_INSTRUCTORS] (state, instructors) {
            state.instructors = instructors;
        },

        [Mutations.SET_USER_BY_ID] (state, id) {
            state.user = state.users.find(user => user.id === id);
        },

        [Mutations.UNSTAGE_USER] (state) {
            state.user = null;
        }
    },
    actions: {
        async getUsers(context) {
            const { data: { content, pageable, totalPages, totalElements, numberOfElements } } =
                await UsersService.getUsers(context.getters.schoolId,
                    PaginationParams.createParams({
                        size: context.getters.pageSize,
                        page: context.getters.pageNumber,
                        sort: context.getters.sortBy,
                        direction: context.getters.direction,
                        query: context.getters.searchQuery,
                        filters: {
                            ...context.getters.filters
                        }
                    }));
            context.commit(Mutations.SET_USERS, content);
            context.dispatch('configPagination', {
                ...pageable,
                numberOfElements,
                totalElements,
                totalPages,
                callback: () => {
                    return context.dispatch('getUsers');
                }
            });
            context.dispatch('resetSelectedItems');
        },

        async getInstructors(context) {
            const { data } = await UsersService.getInstructors(context.getters.schoolId);
            context.commit(Mutations.SET_INSTRUCTORS, data);
        },

        async createUserInvite(context, form) {
            try {
                context.dispatch('showSpinner');
                await UsersInvitationService.createInvite(form);
            } catch (e) {
                throw e;
            } finally {
                setTimeout(() => {
                    context.dispatch('hideSpinner');
                });
            }
        },

        async addInstructor(context, form) {
            try {
                context.dispatch('showSpinner');
                await UsersService.addInstructor(context.getters.schoolId, form);
                await context.dispatch('getInstructors');
            } catch (e) {
                throw e;
            } finally {
                setTimeout(() => {
                    context.dispatch('hideSpinner');
                })
            }
        },

        async createBulkInvite(context, file) {
            await UsersInvitationService.createInviteBulk(context.getters.userId, context.getters.schoolId, file);
        },


        async deleteUser(context, userId) {
            await context.dispatch('deleteUsers', [ userId ]);
        },

        async deleteMultipleUsers(context) {
            await context.dispatch('deleteUsers', context.getters.selected);
            context.dispatch('resetSelectedItems');
        },

        async deleteUsers(context, userIds) {
            await UsersInvitationService.deleteMultipleUsers(context.getters.schoolId, userIds);
            await context.dispatch('resetFilter');
            if (userIds.length === context.getters.users.length) {
                context.dispatch('openPreviousPage');
            }
            await context.dispatch('getUsers');
        },

        async toggleUserStatus(context, userId) {
            await UsersInvitationService.toggleUserStatus(context.getters.schoolId, userId);
            context.dispatch('resetFilter');
            await context.dispatch('getUsers');
        },

        async setContactPerson(context, userId) {
            await SchoolService.setMainContactPerson(context.getters.schoolId, userId);
            context.dispatch('getUsers');
        },

        async toggleInstructorRole(context, userId) {
            await SchoolService.toggleInstructorRole(context.getters.schoolId, userId);
            context.dispatch('getUsers');
        },

        prepareUser(context,payload) {
            const { id, type } = payload;
            context.commit(Mutations.SET_USER_BY_ID, id);
            if (type === 'edit') {
                context.dispatch('openModal', {
                    modalName: 'UserModal',
                    callback: () => context.dispatch('unstageUser')
                });
            } else {
                context.dispatch('openModal', {
                    modalName: 'UsersBulkEmailModal',
                    options: {
                        width: '680px',
                        id
                    },
                    callback: () => context.dispatch('unstageUser')
                });
            }
        },

        unstageUser(context) {
            context.commit(Mutations.UNSTAGE_USER);
        },

        async updateUserRole(context, { userId, role }) {
            await UsersService.updateUserRole(context.getters.schoolId, userId, role);
            await context.dispatch('getUsers');
        }
    },
    getters: {
        users: state => state.users,

        user: state => state.user,

        instructors: state => state.instructors,

        currentUserRole: state => state.user && USER_TYPES.find(role => role.data === state.user.userRole).view
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/users/users.module.js